<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <ApolloQuery
        :query="batchedDepositQuery"
        :variables="{
          nodeId: $route.params.nodeId
        }"
        :notifyOnNetworkStatusChange="true"
      >
        <template v-slot="{ result: { error, loading, data } }">
          <div v-if="error" class="error apollo">
            {{ error }}
          </div>
          <div v-else-if="loading" class="loading apollo">
            Loading...
          </div>
          <div v-else-if="data && data.node">

            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-icon">
                  <md-icon>paid</md-icon>
                </div>
                <h4 class="title">Batched Deposit</h4>
              </md-card-header>

              <md-card-content class="md-layout">
                <div class="md-layout-item md-size-100">
                  <strong>Date:</strong> {{ data.node.for | formatDate }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Period:</strong> {{ data.node.period }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Merchant Name:</strong> {{ data.node.merchant.name }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Merchant Street Address:</strong> {{ data.node.merchant.streetAddress }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>External Memo:</strong> {{ data.node.externalMemo }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Earned Subtotal:</strong> {{ formatBalance(data.node.earnedSubtotalCents) }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Outstanding Balance:</strong> {{ formatBalance(data.node.outstandingCents) }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Total:</strong> {{ formatBalance(data.node.totalCents) }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Submitted At:</strong> {{ data.node.submittedAt | formatDatetime }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Last Known Transaction Status:</strong> {{ data.node.lastKnownTransactionStatus }}
                </div>
                <div class="md-layout-item md-size-100">
                  <strong>Last Known Transaction ID:</strong> {{ data.node.lastKnownTransactionId }}
                </div>
              </md-card-content>
            </md-card>
          </div>
        </template>
      </ApolloQuery>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { BatchedDepositQuery } from "@/graphql.js";
import { Badge } from "@/components";
import IntToMoneyFormatter from "@/mixins/money-formatter-mixin.js"

export default {
  name: "BatchedDeposit",
  components: {
    Badge,
  },
  mixins: [ IntToMoneyFormatter ],
  methods: {
    batchedDepositQuery() {
      return BatchedDepositQuery;
    },
  },
  filters: {
    formatDate(str) {
      return moment(str).format('MM/DD/YY');
    },
    formatDatetime(str) {
      return str
        ? moment(str).utc().tz('America/New_York').format('hh:mm MM/DD/YY A z')
        : '';
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
